import React, { useState } from 'react';
import './CustomTooltip.scss';

const CustomTooltip = ({ text, placement = "top", children, show= true }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <div 
      className="custom-tooltip-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && show &&(
        <div className={`custom-tooltip custom-tooltip-${placement}`}>
          <div className="custom-tooltip-content">
            {text}
          </div>
          <div className={`custom-tooltip-arrow custom-tooltip-arrow-${placement}`}></div>
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
